// 语言本地化
const LocalLanguageList = {
  id: 'Bahasa Indonesia',
  ms: 'Bahasa Melayu',
  bs: 'Босански',
  ca: 'Català',
  cs: 'Čeština',
  da: 'Dansk',
  de: 'German',
  et: 'Eesti',
  en: 'English',
  es: 'Español',
  eu: 'Euskara',
  fil: 'Filipino',
  fr: 'Français',
  ga: 'Gaeilge',
  gl: 'Galego',
  hr: 'Hrvatski',
  is: 'Íslenska',
  it: 'Italiano',
  lv: 'Latviešu',
  lb: 'Lëtzebuergesch',
  lt: 'Lietuvių',
  hu: 'Magyar',
  mt: 'Malti',
  nl: 'Nederlands',
  nb: 'Norsk Bokmål',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  sk: 'Slovenčina',
  sl: 'Slovenski',
  sr: 'Српски',
  fi: 'Suomi',
  sv: 'Svenska',
  vi: 'TiếngViệt',
  tr: 'Türkçe',
  el: 'Ελληνικά',
  bg: 'Български',
  kk: 'қазақ тілі',
  ru: 'Русский',
  uk: 'Українська',
  he: 'עברית‏',
  ar: 'العربية',
  hi: 'हिंदी',
  th: 'ไทย',
  ko: '한국어',
  zh: '中文 (繁體)',
  ja: '日本語',
  cn: '中文 (简体)',
  hk: '中文 (繁體)',
  tw: '中文 (繁體)',
}

const LangIdMap = {
  Nav_1: 'kop-01',
  Nav_2: 'kop-02',
  Nav_3: 'kop-03',
  CarouseTitle: 'kop-04',
  CarouseSubtitle: 'kop-05',
  CarouselButton: 'kop-06',
  FooterTitle: 'kop-07',
  FooterNav_1: 'kop-08',
  FooterNav_2: 'kop-09',
  FooterHeader: 'kop-10',
  FooterText: 'kop-11',
  SeoTitle: 'kop-12',
  SeoDesc: 'kop-13',
  StoreTitle: 'kop-14',
  ActivityTitle: 'kop-15',
  ActivityRuleTitle: 'kop-314',
  ActivityDesc: 'kop-16',
  ActivityRuleDesc: 'kop-315',
  ImageTextTitle: 'kop-17',
  ImageTextDesc: 'kop-18',
  CollapseTitle: 'kop-19',
  AccountDescribe: 'kop-20',
  SignTitle: 'kop-1419',
  SignSubtitle: 'kop-1684',
  DialogTitle: 'kop-1412',
  DialogSubtitle: 'kop-1409',
  ConvertKeyTitle: 'kop-1021',
  ConvertKeySubtitle: 'kop-1125',
  ConsecutiveTitle: 'kop-1311',
  ConsecutiveSubtitle: 'kop-3322',
  MonthCardTitle: 'kop-182',
  MonthCardSubtitle: 'kop-183',
  MonthCardRule1: 'kop-176',
  MonthCardRule2: 'kop-177',
  MonthCardRule3: 'kop-178',
  MonthCardRule4: 'kop-179',
  MonthCardRule5: 'kop-180',
  MonthCardRule6: 'kop-181',
  StoreListTitle: 'kop-185',
  StoreListSubtitle: 'kop-186',
  FooterMediaTitle: 'kop-188',
  SignSecondTitle: 'kop-196',
  SignSecondSubtitle: 'kop-197',
  PwaTitle: 'kop-209',
  PwaBtnTitle: 'kop-210',
  TextContent: 'kop-211',
  singleGoodsTitle: 'kop-241',
  singleGoodsSubtitle: 'kop-242',
  inviteCodeTitle: 'kop-213',
  inviteCodeTitleSubtitle: 'kop-214',
  inviteCodeRule: 'kop-215',
  StoreV2Title: 'kop-258',
  vipUserRuleTitle: 'kop-259',
  vipUserRuleText1: 'kop-285',
  vipUserRuleText2: 'kop-286',
  vipUserRuleText3: 'kop-287',
  vipUserRuleText4: 'kop-288',
  vipUserRuleText5: 'kop-289',
  vipUserRuleText6: 'kop-290',
  vipUserRuleText7: 'kop-291',
  vipUserRuleText8: 'kop-294',
  vipUserRuleText9: 'kop-293',
  vipPointStoreTitle: 'kop-260',
  RechargeV2Title: 'kop-296',
  RechargeV2Subtitle: 'kop-297',
  MissionCenterTitle: 'kop-307',
  RechargeHandleButtonText: 'kop-316',
  DialogBlockItemDesc: 'kop-317',
  DialogCollectionButton: 'kop-318',
  'siteBuild.header.exit': 'kop-21',
  'siteBuild.header.please': 'kop-22',
  'siteBuild.header.login': 'kop-23',
  'siteBuild.header.userId': 'kop-24',
  'siteBuild.header.goto': 'kop-25',
  'siteBuild.header.backLogin': 'kop-26',
  'siteBuild.header.bindUserAccount': 'kop-27',
  'siteBuild.header.placeHolderUserID': 'kop-28',
  'siteBuild.header.accountDetail': 'kop-29',
  'siteBuild.header.userName': 'kop-30',
  'siteBuild.header.warZone': 'kop-31',
  'siteBuild.header.userInfo': 'kop-32',
  'siteBuild.header.register': 'kop-33',
  'siteBuild.header.registerSuccess': 'kop-34',
  'siteBuild.header.backSignIn': 'kop-35',
  'siteBuild.header.resetSignIn': 'kop-36',
  'siteBuild.header.signInFormTitle': 'kop-37',
  'siteBuild.header.signUpFormTitle': 'kop-38',
  'siteBuild.header.forgetFormTitle': 'kop-39',
  'siteBuild.header.confirm': 'kop-40',
  'siteBuild.header.registerDetailTitle': 'kop-41',
  'siteBuild.header.scanSign': 'kop-42',
  'siteBuild.header.loginButton': 'kop-43',
  'siteBuild.header.registerNow': 'kop-44',
  'siteBuild.header.noAccountPleaseClick': 'kop-45',
  'siteBuild.header.sendMailSuccess': 'kop-46',
  'siteBuild.header.registerButton': 'kop-47',
  'siteBuild.header.createAccountButton': 'kop-48',
  'siteBuild.header.rememberMe': 'kop-49',
  'siteBuild.header.forgetPassword': 'kop-50',
  'siteBuild.header.otherSignIn': 'kop-51',
  'siteBuild.header.receiveEmail': 'kop-52',
  'siteBuild.header.nextStep': 'kop-53',
  'siteBuild.header.mailSendTo': 'kop-54',
  'siteBuild.header.lookMail': 'kop-55',
  'siteBuild.header.loginSuccessTitle': 'kop-56',
  'siteBuild.header.loginSuccessDesc': 'kop-57',
  'siteBuild.header.accountPlaceholder': 'kop-58',
  'siteBuild.header.passwordPlaceholder': 'kop-59',
  'siteBuild.header.smsPlaceholder': 'kop-60',
  'siteBuild.header.mobilePlaceholder': 'kop-61',
  'siteBuild.header.policyPlaceholder': 'kop-62',
  'siteBuild.header.diffPwd': 'kop-63',
  'siteBuild.header.mailRequireMessage': 'kop-64',
  'siteBuild.header.mailValidateMessage': 'kop-65',
  'siteBuild.header.passwordValidateMessage': 'kop-66',
  'siteBuild.header.passwordValidateMinMessage': 'kop-67',
  'siteBuild.header.findBackPassword': 'kop-68',
  'siteBuild.header.findBankPasswordDesc': 'kop-69',
  'siteBuild.header.userAccount': 'kop-70',
  'siteBuild.header.password': 'kop-71',
  'siteBuild.header.confirmPassword': 'kop-72',
  'siteBuild.header.email': 'kop-73',
  'siteBuild.header.smsCode': 'kop-74',
  'siteBuild.header.mobile': 'kop-75',
  'siteBuild.header.loginByUid': 'kop-76',
  'siteBuild.header.loginByEmail': 'kop-77',
  'siteBuild.confirm': 'kop-78',
  'siteBuild.cancel': 'kop-79',
  'siteBuild.store.titleText': 'kop-80',
  'siteBuild.store.buyNow': 'kop-81',
  'siteBuild.store.noPrice': 'kop-82',
  'siteBuild.store.defaultProductName': 'kop-83',
  'siteBuild.store.defaultProductDescription': 'kop-84',
  'siteBuild.store.soldOut': 'kop-85',
  'siteBuild.subTotal': 'kop-86',
  'siteBuild.tax': 'kop-87',
  'siteBuild.totalAmount': 'kop-88',
  'siteBuild.buyGoods': 'kop-89',
  'siteBuild.consecutive': 'kop-174',
  'siteBuild.gift': 'kop-90',
  'siteBuild.activity.my': 'kop-91',
  'siteBuild.activity.activityTime': 'kop-92',
  'siteBuild.activity.haveGet': 'kop-93',
  'siteBuild.activity.get': 'kop-94',
  'siteBuild.activity.notQualified': 'kop-95',
  'siteBuild.activity.tips_1': 'kop-96',
  'siteBuild.header.send': 'kop-97',
  'siteBuild.free': 'kop-98',
  'siteBuild.activity.rechargeTip': 'kop-99',
  'siteBuild.activity.rechargeTip1': 'kop-100',
  'siteBuild.shopCart.title': 'kop-101',
  'siteBuild.shopCart.backList': 'kop-102',
  'siteBuild.shopCart.allDelete': 'kop-103',
  'siteBuild.shopCart.selectAll': 'kop-104',
  'siteBuild.shopCart.goodsName': 'kop-105',
  'siteBuild.shopCart.number': 'kop-106',
  'siteBuild.shopCart.price': 'kop-107',
  'siteBuild.shopCart.handle': 'kop-108',
  'siteBuild.shopCart.buy': 'kop-109',
  'siteBuild.shopCart.total': 'kop-113',
  'siteBuild.shopCart.noData': 'kop-114',
  'siteBuild.shopCart.gift': 'kop-116',
  'siteBuild.signWidget.tip1': 'kop-110',
  'siteBuild.signWidget.tip2': 'kop-111',
  'siteBuild.signWidget.tip3': 'kop-112',
  'siteBuild.activity.addUp': 'kop-115',
  'siteBuild.convertKey': 'kop-117',
  'siteBuild.convert': 'kop-118',
  'siteBuild.convertTip1': 'kop-119',
  'siteBuild.register.tip1': 'kop-124',
  'siteBuild.register.tip2': 'kop-125',
  'siteBuild.register.tip3': 'kop-126',
  'siteBuild.header.login1': 'kop-127',
  // 'siteBuild.lotteryWidget.drawHistory': 'kop-121',
  'siteBuild.lotteryWidget.count': 'kop-122',
  'siteBuild.lotteryWidget.consecutive': 'kop-123',
  // 'siteBuild.lotteryWidget.ruleTitle': 'kop-128',
  'siteBuild.lotteryWidget.skipAnimation': 'kop-171',
  'siteBuild.monthCardWidget.nowGet': 'kop-172',
  'siteBuild.monthCardWidget.dayGet': 'kop-173',
  'siteBuild.header.server': 'kop-189',
  'siteBuild.consecutiveWidget.subtitle': 'kop-187',
  'siteBuild.fullDiscount': 'kop-191',
  'siteBuild.includes': 'kop-192',
  'siteBuild.pwaWidget.title': 'kop-193',
  'siteBuild.pwaWidget.tip1': 'kop-194',
  'siteBuild.pwaWidget.tip2': 'kop-195',
  'siteBuild.signWidget.day': 'kop-198',
  'siteBuild.signWidget.sign': 'kop-199',
  'siteBuild.signWidget.repair': 'kop-200',
  'siteBuild.noActivity': 'kop-201',
  'siteBuild.signWidget.signed': 'kop-202',
  'siteBuild.signWidget.conDay': 'kop-203',
  'siteBuild.signWidget.reward': 'kop-204',
  'siteBuild.reward': 'kop-205',
  'siteBuild.monthCardWidget.congratulate': 'kop-206',
  'siteBuild.convertInput': 'kop-207',
  'siteBuild.orderInfo': 'kop-208',
  'siteBuild.all': 'kop-212',
  'siteBuild.inviteGuide': 'kop-216',
  'siteBuild.inviteHistory': 'kop-217',
  'siteBuild.createInviter': 'kop-218',
  "siteBuild.copyInviteCode": 'kop-219',
  "siteBuild.inviteNumberTip": 'kop-220',
  'siteBuild.inviterTip': 'kop-221',
  'siteBuild.payment': 'kop-222',
  'siteBuild.inviteeTip': 'kop-223',
  'siteBuild.imInvitee': 'kop-224',
  'siteBuild.inviteCodeTip': 'kop-225',
  'siteBuild.bindInviteCode': 'kop-226',
  'siteBuild.step1': 'kop-227',
  'siteBuild.step2': 'kop-228',
  'siteBuild.step3': 'kop-229',
  'siteBuild.step4': 'kop-230',
  'siteBuild.step5': 'kop-231',
  'siteBuild.inviteGuideTip1': 'kop-232',
  'siteBuild.inviteGuideTip2': 'kop-233',
  'siteBuild.inviteGuideTip3': 'kop-234',
  'siteBuild.inviteGuideTip4': 'kop-235',
  'siteBuild.inviteGuideTip5': 'kop-236',
  'siteBuild.invitee': 'kop-237',
  'siteBuild.loginTime': 'kop-238',
  'siteBuild.ruleDesc': 'kop-239',
  'siteBuild.inputInviteCode': 'kop-240',
  'model.editorCodeBlock': 'kop-243',
  'model.store': 'kop-244',
  'model.imageText': 'kop-245',
  'model.collapse': 'kop-246',
  'model.activity': 'kop-247',
  'model.recharge': 'kop-248',
  'model.signActivity': 'kop-249',
  'model.convertKey': 'kop-250',
  'model.consecutive': 'kop-251',
  'model.lottery': 'kop-252',
  'model.monthCard': 'kop-253',
  'model.storeList': 'kop-254',
  'model.text': 'kop-255',
  'model.singleGoods': 'kop-256',
  'model.inviteCode': 'kop-257',
  'siteBuild.vipUserInfoWidget.currentPoint': 'kop-261',
  'siteBuild.vipUserInfoWidget.pointTip': 'kop-262',
  'siteBuild.vipUserInfoWidget.tip1': 'kop-263',
  'siteBuild.vipUserInfoWidget.tip2': 'kop-264',
  'siteBuild.vipUserInfoWidget.tip3': 'kop-265',
  'siteBuild.vipUserInfoWidget.currentLevel': 'kop-266',
  'siteBuild.vipUserInfoWidget.growthTip': 'kop-267',
  'siteBuild.vipUserInfoWidget.overLevel': 'kop-268',
  'siteBuild.vipUserInfoWidget.updateTip': 'kop-269',
  'siteBuild.vipUserInfoWidget.pointScale': 'kop-270',
  'siteBuild.vipUserInfoWidget.giftPoints': 'kop-271',
  'siteBuild.email': 'kop-272',
  'siteBuild.redeem': 'kop-273',
  'siteBuild.refund': 'kop-274',
  'siteBuild.expiry': 'kop-275',
  'siteBuild.growth': 'kop-276',
  'siteBuild.points': 'kop-277',
  'siteBuild.currentGrowth': 'kop-278',
  'siteBuild.currentPoint': 'kop-279',
  'siteBuild.allType': 'kop-280',
  'siteBuild.income': 'kop-281',
  'siteBuild.outlay': 'kop-282',
  'siteBuild.upgrade': 'kop-283',
  'siteBuild.stopCountdown': 'kop-284',
  'siteBuild.maxTip': 'kop-295',
  'siteBuild.expired': 'kop-298',
  'siteBuild.newPassword': 'kop-299',
  'siteBuild.placeholderNewPassword': 'kop-300',
  'siteBuild.confirmNewPassword': 'kop-301',
  'siteBuild.placeholderConfirmNewPassword': 'kop-302',
  'siteBuild.lotteryWidget.cycleTip': 'kop-303',
  'message.code429': 'kop-304',
  'message.code500': 'kop-305',
  'siteBuild.enterAmount': 'kop-306',
  'siteBuild.pwaLogin': 'kop-308',
  'siteBuild.quickGet': 'kop-309',
  'siteBuild.do': 'kop-310',
  'siteBuild.done': 'kop-311',
  "siteBuild.install": "kop-312",
  "siteBuild.missionCenter": "kop-313",
  'siteBuild.customNumber': 'kop-319',
  'siteBuild.pwaWidget.tip3': 'kop-320'
}

const SiteBuildIdFlag = 'kop-'

export {
  LocalLanguageList,
  LangIdMap,
  SiteBuildIdFlag
}
